  const l = 42, // 滑块边长
    r = 10, // 滑块半径
    w = 300, // canvas宽度
    h = 155, // canvas高度
    PI = Math.PI
  const L = l + r * 2 // 滑块实际边长

  function getRandomNumberByRange(start, end) {
    return Math.round(Math.random() * (end - start) + start)
  }

  function createCanvas(width, height) {
    const canvas = createElement('canvas')
    canvas.width = width
    canvas.height = height
    return canvas
  }

  function createImg(onload) {
    const img = createElement('img')
    img.crossOrigin = "Anonymous"
    img.onload = onload
    img.onerror = () => {
      img.src = getRandomImg()
    }
    img.src = getRandomImg()
    return img
  }

  function createElement(tagName) {
    return document.createElement(tagName)
  }

  function addClass(tag, className) {
    tag.classList.add(className)
  }

  function removeClass(tag, className) {
    tag.classList.remove(className)
  }

  function getRandomImg() {
    return '../static/images/sliderBar/' + getRandomNumberByRange(1, 4)+'.jpg'
  }

  function draw(ctx_s, operation, X, Y) {
    let r = 12;
    if(operation=='fill'){
      r = 13;
      ctx_s.globalCompositeOperation = "xor";
    }
    ctx_s.beginPath()
    ctx_s.moveTo(X, Y);
    ctx_s.lineTo(X + r, Y);
    ctx_s.bezierCurveTo(X + r, Y - r, X + 2 * r, Y - r, X + 2 * r, Y);
    ctx_s.lineTo(X + 3 * r, Y);
    ctx_s.lineTo(X + 3 * r, Y + r);
    ctx_s.bezierCurveTo(X + 2 * r, Y + r, X + 2 * r, Y + 2 * r, X + 3 * r, Y + 2 * r);
    ctx_s.lineTo(X + 3 * r, Y + 3 * r);
    ctx_s.lineTo(X, Y + 3 * r);
    ctx_s.closePath();
    if(operation=='clip')ctx_s.clip();
    ctx_s.fill()
  }


  function draw2(ctx_s, operation, X, Y) {
    let r = 12;
    ctx_s.beginPath();
    ctx_s.strokeStyle = "rgba(255,255,255,1)";
    ctx_s.lineWidth="3";
    ctx_s.moveTo(X, Y);
    ctx_s.lineTo(X + r, Y);
    ctx_s.bezierCurveTo(X + r, Y - r, X + 2 * r, Y - r, X + 2 * r, Y);
    ctx_s.lineTo(X + 3 * r, Y);
    ctx_s.lineTo(X + 3 * r, Y + r);
    ctx_s.bezierCurveTo(X + 2 * r, Y + r, X + 2 * r, Y + 2 * r, X + 3 * r, Y + 2 * r);
    ctx_s.lineTo(X + 3 * r, Y + 3 * r);
    ctx_s.lineTo(X, Y + 3 * r);
    ctx_s.closePath();
    ctx_s.shadowBlur = 20;
    ctx_s.shadowColor = "black";
    ctx_s.stroke();
    ctx_s.fill();
  }

  function sum(x, y) {
    return x + y
  }

  function square(x) {
    return x * x
  }

  class jigsaw {
    constructor(el, success, fail) {
      this.el = el
      this.success = success
      this.fail = fail
    }

    init() {
      this.initDOM()
      this.initImg()
      this.draw()
      this.bindEvents()
      addClass(this.canvas,'hide');
      addClass(this.block,'hide');
      addClass(this.shadow,'hide');
    }

    initDOM() {
      const canvas = createCanvas(w, h) // 画布
      const shadow = canvas.cloneNode(true) // 阴影
      const block = canvas.cloneNode(true) // 滑块
      const sliderContainer = createElement('div')
      const refreshIcon = createElement('div')
      const sliderMask = createElement('div')
      const slider = createElement('div')
      const sliderIcon = createElement('span')
      const text = createElement('span')
      canvas.id="canvas";
      block.className = 'block'
      //shadow.className = 'block'
      sliderContainer.className = 'sliderContainer'
      refreshIcon.className = 'refreshIcon'
      sliderMask.className = 'sliderMask'
      slider.className = 'slider'
      sliderIcon.className = 'sliderIcon'
      text.innerHTML = '向右滑动滑块填充拼图，完成验证'
      text.className = 'sliderText'

      const el = this.el
      el.appendChild(canvas)
      el.appendChild(refreshIcon)
      el.appendChild(shadow)
      el.appendChild(block)
      slider.appendChild(sliderIcon)
      sliderMask.appendChild(slider)
      sliderContainer.appendChild(sliderMask)
      sliderContainer.appendChild(text)
      el.appendChild(sliderContainer)

      Object.assign(this, {
        canvas,
        block,
        shadow,
        sliderContainer,
        refreshIcon,
        slider,
        sliderMask,
        sliderIcon,
        text,
        canvasCtx: canvas.getContext('2d'),
        blockCtx: block.getContext('2d'),
        shadowCtx: shadow.getContext('2d')
      })
    }

    initImg() {
      const img = createImg(() => {
        this.canvasCtx.drawImage(img, 0, 0, w, h)
        this.blockCtx.drawImage(img, 0, 0, w, h)
        const y = this.y - r * 2 + 2
        const ImageData = this.blockCtx.getImageData(this.x, y, L, L)
        this.block.width  = L
        this.shadow.style.left = `-${this.x}px`;
        this.blockCtx.putImageData(ImageData, 0, y)
      })
      this.img = img
    }

    draw() {
      // 随机创建滑块的位置
      this.x = getRandomNumberByRange(L + 10, w - (L + 10))
      this.y = getRandomNumberByRange(10 + r * 2, h - (L + 10))
      draw(this.canvasCtx, 'fill', this.x, this.y)
      draw(this.blockCtx, 'clip', this.x, this.y)
      draw2(this.shadowCtx,'clip', this.x, this.y)
    }

    clean() {
      this.canvasCtx.clearRect(0, 0, w, h)
      this.blockCtx.clearRect(0, 0, w, h)
      this.shadowCtx.clearRect(0, 0, w, h)
      this.block.width = w
    }

    bindEvents() {
      this.el.onselectstart = () => false
      this.refreshIcon.onclick = () => {
        this.reset()
      }

      let originX, originY, trail = [], isMouseDown = false;

      let canvas = this.canvas;
      let block = this.block;
      let shadow = this.shadow;
      this.slider.addEventListener('mouseenter', function (e) {
        removeClass(canvas,'hide');
        removeClass(block,'hide');
        removeClass(shadow,'hide');
      })
      this.slider.addEventListener('mouseleave', function (e) {
        if(isMouseDown)return;
        addClass(canvas,'hide');
        addClass(block,'hide');
        addClass(shadow,'hide');
      })

      this.slider.addEventListener('mousedown', function (e) {
        originX = e.x, originY = e.y
        isMouseDown = true
      })
      document.addEventListener('mousemove', (e) => {
        if (!isMouseDown) return false
        const moveX = e.x - originX
        const moveY = e.y - originY
        if (moveX < 0 || moveX + 38 >= w) return false
        this.slider.style.left = moveX + 'px'
        var blockLeft = (w - 40 - 20) / (w - 40) * moveX
        this.block.style.left = blockLeft + 'px'
        this.shadow.style.left = blockLeft-this.x + 'px'

        addClass(this.sliderContainer, 'sliderContainer_active')
        this.sliderMask.style.width = moveX + 'px'
        trail.push(moveY)
      })
      document.addEventListener('mouseup', (e) => {
        if (!isMouseDown) return false
        isMouseDown = false
        if (e.x == originX) return false
        removeClass(this.sliderContainer, 'sliderContainer_active')
        this.trail = trail
        const {spliced, TuringTest} = this.verify()
        if (spliced) {
          if (TuringTest) {
            addClass(this.sliderContainer, 'sliderContainer_success')
            this.success && this.success()
          } else {
            addClass(this.sliderContainer, 'sliderContainer_fail')
            this.text.innerHTML = '再试一次'
            this.reset()
          }
          addClass(canvas,'hide');
          addClass(block,'hide');
          addClass(shadow,'hide');
        } else {
          addClass(this.sliderContainer, 'sliderContainer_fail')
          this.fail && this.fail()
          setTimeout(() => {
            this.reset()
          }, 1000)
        }
      })
    }

    verify() {
      const arr = this.trail // 拖动时y轴的移动距离
      const average = arr.reduce(sum) / arr.length // 平均值
      const deviations = arr.map(x => x - average) // 偏差数组
      const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length) // 标准差
      const left = parseInt(this.block.style.left)
      return {
        spliced: Math.abs(left - this.x) < 10,
        TuringTest: average !== stddev, // 只是简单的验证拖动轨迹，相等时一般为0，表示可能非人为操作
      }
    }

    reset() {
      this.sliderContainer.className = 'sliderContainer'
      this.slider.style.left = 0
      this.block.style.left = 0
      this.sliderMask.style.width = 0
      this.clean()
      this.img.src = getRandomImg()
      this.draw()
    }

  }

export const fnJigsaw = (element, success, fail) => {
    new jigsaw(element, success, fail).init()
}



// WEBPACK FOOTER //
// ./src/components/password/waterSystemlogin/jigsaw.js